import {Instance, types as t} from 'mobx-state-tree'

const UiStore = t.model('UiStore')
  .props({
    globalLoader: t.optional(t.boolean, false)
  })
  .actions((self) => {
    const actions = {
      setGlobalLoader (newLoaderStatus: boolean) {
        self.globalLoader = newLoaderStatus
      }
    }

    return actions
  })


export default UiStore
export type UiStoreType = Instance<typeof UiStore>
